import { request } from ".";
import type {
  AiAnalyzeImageRequest,
  AiAnalyzeImageResponse,
  BuildVideoReferenceScriptRequest,
  BuildVideoReferenceScriptResponse,
  ProductInfoByLinkResponse,
  ResultListUploadImageByUrlImageItem,
  VideoCreationRequest,
} from "./api.types";
import { clipHttpClient } from "./http/createClipHttpClient";
export * from "./api.types";

// 从商品链接解析商品信息与图片列表（`request` 解包后为 ProductInfoByLinkResponse）
export const fetchParseInfoByLink = async (body: { url: string }) => {
  return clipHttpClient.request<ProductInfoByLinkResponse>({
    method: "POST",
    url: `/api/product/parse-info-by-link`,
    body,
    timeoutMs: 3 * 60 * 1000,
    context: { silent: true },
  });
};

export const fetchUploadImagesByUrl = async (images: { url: string; description: string }[]) => {
  return request<ResultListUploadImageByUrlImageItem[]>({
    method: "post",
    url: "/api/video/upload-images-by-url",
    data: images,
    timeout: 180000,
  });
};

export const fetchAiAnalyzeImage = async (data: AiAnalyzeImageRequest) => {
  return request<AiAnalyzeImageResponse[]>({
    method: "post",
    url: "/api/product/image-check-and-describe",
    data,
    timeout: 180000,
  });
};

// 获取商品信息
const fetchProductDetail = async (data: { id: string; country: string }) => {
  return request<string[]>({
    method: "post",
    url: `/api/product/detail`,
    data,
  });
};

// 生成视频参考脚本
export const fetchReferenceScript = async (data: BuildVideoReferenceScriptRequest) => {
  return request<BuildVideoReferenceScriptResponse>({
    method: "post",
    url: `/api/video/reference-script`,
    data,
    timeout: 180000,
  });
};

// 创建视频
const videoCreation = async (data: VideoCreationRequest) => {
  return request<any>({
    method: "post",
    url: "/api/video/creation",
    data,
  });
};

// 重试已完成的视频生成任务
const videoRecreation = async (data: { jobId: number; internalModelId: string }) => {
  return request<any>({
    method: "post",
    url: `/api/video/recreation`,
    data,
  });
};

export default {
  fetchProductDetail,
  fetchParseInfoByLink,
  videoCreation,
  videoRecreation,
};
